import { render, staticRenderFns } from "./HomeTasksList.vue?vue&type=template&id=3ecd9baa"
import script from "./HomeTasksList.vue?vue&type=script&lang=js"
export * from "./HomeTasksList.vue?vue&type=script&lang=js"
import style0 from "./HomeTasksList.vue?vue&type=style&index=0&id=3ecd9baa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports